/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useSelector, useDispatch } from "react-redux";
import { ALL_ARRAY, TODO_ARRAY, SEE_ARRAY, EAT_ARRAY } from "../../constants";
import {
  orderByDistance,
  getDistance,
  getPreciseDistance,
  convertDistance,
} from "geolib";
import { useHistory } from "react-router-dom";
import isMobile from "ismobilejs";
import { toggleFavorites } from "../../actions/favorites";
import { format } from "date-fns";
import SwiperHeader from "./SwiperHeader";
import "swiper/swiper.scss";
import SwiperCore, { Navigation } from "swiper";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Card from "../Card/index";
import { useFetchUser } from "../../hooks/useFetchUser";

const DefaultSwip = styled.div`
  padding-left: 49px;

  @media (max-width: 768px) {
    padding-left: 16px;
  }

  ${(props) =>
    props.nopadding &&
    `
    padding-left: 0;

    @media (max-width: 768px) {
      padding-left: 0;
    }
  `}

  .swiper-container {
    padding: 0 49px 0 0;

    @media (max-width: 768px) {
      padding: 0 16px 0 0;
    }
  }

  .swiper-slide {
    /* Ensure card takes full slide width */
    > div {
      width: 100%;
    }

    /* Limit card title to 2 lines */
    h3 {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 1.2em;
      max-height: 2.4em; /* 2 lines * 1.2em line-height */
      text-transform: lowercase !important;

      // Capitalize first letter for first word
      &::first-letter {
        text-transform: uppercase !important;
      }
    }
  }

  /* Fix navigation positioning */
  .swiper-button-next,
  .swiper-button-prev {
    color: ${(props) => props.theme?.colors?.primary || "#007bff"};

    &:after {
      font-size: 18px;
      font-weight: bold;
    }
  }

  .swiper-button-disabled {
    opacity: 0.3;
  }
`;
function DefaultSwiper({
  slides,
  main,
  sub,
  similar,
  todo,
  nohead,
  getSafe,
  nearby,
  position,
  origin,
  shuffledPlaces,
  shufflePlaces = () => {},
  filter,
  exp,
  event,
  cityfilter,
  nopadding,
}) {
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const { local } = useSelector((state) => state.Local);
  const { t } = useTranslation();
  const { filters } = useSelector((state) => state.Filters);

  const { data: user = {} } = useFetchUser();

  const [status, setStatus] = React.useState(null);
  const [arraySlide, setArray] = React.useState(null);
  const [todoPlaces, setTodoPlaces] = useState();

  useEffect(() => {
    if (status && todo) {
      status === "Do"
        ? setArray(TODO_ARRAY)
        : status === "Eat & Drink"
        ? setArray(EAT_ARRAY)
        : status === "See"
        ? setArray(SEE_ARRAY)
        : status === "All"
        ? setArray(ALL_ARRAY)
        : setArray(ALL_ARRAY);
    }
    if (slides && Array.isArray(slides)) {
      let output = getSafe(() => slides);
      if (filter && Array.isArray(filter) && !exp) {
        output = slides.filter(
          (p) =>
            filter.indexOf(p.tags[0]?.slug) > -1 ||
            filter.indexOf(p.tags[1]?.slug) > -1 ||
            filter.indexOf(p.tags[2]?.slug) > -1
        );
      }
      if (filter && Array.isArray(filter) && exp) {
        output = slides.filter((p) =>
          p.places.filter((q) => filter.indexOf(q.tags[0]?.slug) > -1)
        );
      }
      if (cityfilter && Array.isArray(cityfilter) && !exp) {
        output = slides.filter(
          (p) => cityfilter.indexOf(p.contact.address.city) > -1
        );
      }
      if (cityfilter && Array.isArray(cityfilter) && exp) {
        output = slides.filter((p) =>
          p.places.filter(
            (t) => cityfilter.indexOf(t.contact.address.city) > -1
          )
        );
      }
      if (arraySlide && Array.isArray(arraySlide) && todo) {
        output = slides.filter((p) => {
          return (
            p.tags &&
            (arraySlide.indexOf(p.tags[0]?.slug) > -1 ||
              arraySlide.indexOf(p.tags[1]?.slug) > -1 ||
              arraySlide.indexOf(p.tags[2]?.slug) > -1)
          );
        });
      }
      if (user && !origin && todo) {
        // Validate user coordinates first
        const hasValidUserCoords =
          user.latitude &&
          user.longitude &&
          !isNaN(user.latitude) &&
          !isNaN(user.longitude);

        if (hasValidUserCoords) {
          try {
            output = output
              .map((o, i) => {
                // Validate location coordinates before calculating distance
                const hasValidLocationCoords =
                  o.location?.coordinates &&
                  Array.isArray(o.location.coordinates) &&
                  o.location.coordinates.length === 2 &&
                  !isNaN(o.location.coordinates[0]) &&
                  !isNaN(o.location.coordinates[1]);

                if (hasValidLocationCoords) {
                  return {
                    ...o,
                    distance: getDistance(
                      {
                        latitude: o.location.coordinates[1],
                        longitude: o.location.coordinates[0],
                      },
                      {
                        latitude: user.latitude,
                        longitude: user.longitude,
                      }
                    ),
                  };
                }
                return o; // Return without distance if coordinates invalid
              })
              .sort(
                (s, v) => (s.distance || Infinity) - (v.distance || Infinity)
              );
          } catch (error) {
            console.error("Error calculating distances:", error);
          }
        } else {
          console.warn(
            "Invalid user coordinates, skipping distance calculation"
          );
        }
      }

      if (origin && Array.isArray(origin) && origin.length === 2) {
        // Validate origin coordinates
        const hasValidOriginCoords = !isNaN(origin[0]) && !isNaN(origin[1]);

        if (hasValidOriginCoords) {
          try {
            const validItems = output
              .map((t) => {
                if (
                  t &&
                  t.location &&
                  t.location?.coordinates &&
                  Array.isArray(t.location.coordinates) &&
                  t.location.coordinates.length === 2 &&
                  !isNaN(t.location.coordinates[0]) &&
                  !isNaN(t.location.coordinates[1])
                ) {
                  return {
                    ...t,
                    latitude: getSafe(() => t.location.coordinates[1]),
                    longitude: getSafe(() => t.location.coordinates[0]),
                  };
                }
                return null;
              })
              .filter(Boolean); // Remove null entries

            output = orderByDistance(
              { latitude: origin[1], longitude: origin[0] },
              validItems
            );
          } catch (error) {
            console.error("Error ordering by distance from origin:", error);
          }
        } else {
          console.warn("Invalid origin coordinates provided");
        }
      }
      // Additional distance calculation for first 20 items when origin exists
      if (origin && Array.isArray(origin) && origin.length === 2) {
        const hasValidOriginCoords = !isNaN(origin[0]) && !isNaN(origin[1]);

        if (hasValidOriginCoords) {
          try {
            output = output.map((o, i) => {
              if (i < 20) {
                // Validate location coordinates
                const hasValidLocationCoords =
                  o.location?.coordinates &&
                  Array.isArray(o.location.coordinates) &&
                  o.location.coordinates.length === 2 &&
                  !isNaN(o.location.coordinates[0]) &&
                  !isNaN(o.location.coordinates[1]);

                if (hasValidLocationCoords) {
                  return {
                    ...o,
                    distance: getDistance(
                      {
                        latitude: o.location.coordinates[1],
                        longitude: o.location.coordinates[0],
                      },
                      {
                        latitude: origin[1],
                        longitude: origin[0],
                      }
                    ),
                  };
                }
              }
              return o;
            });
          } catch (error) {
            console.error("Error calculating distances from origin:", error);
          }
        }
      }

      if (!origin && Array.isArray(user)) {
        // Validate user coordinates when user is an array
        const hasValidUserCoords =
          user.latitude &&
          user.longitude &&
          !isNaN(user.latitude) &&
          !isNaN(user.longitude);

        if (hasValidUserCoords) {
          try {
            const validItems = output
              .map((t) => {
                if (
                  t &&
                  t.location &&
                  t.location?.coordinates &&
                  Array.isArray(t.location.coordinates) &&
                  t.location.coordinates.length === 2 &&
                  !isNaN(t.location.coordinates[0]) &&
                  !isNaN(t.location.coordinates[1])
                ) {
                  return {
                    ...t,
                    latitude: getSafe(() => t.location.coordinates[1]),
                    longitude: getSafe(() => t.location.coordinates[0]),
                  };
                }
                return null;
              })
              .filter(Boolean); // Remove null entries

            output = orderByDistance(
              { latitude: user.latitude, longitude: user.longitude },
              validItems
            );
          } catch (error) {
            console.error("Error ordering by user coordinates:", error);
          }
        } else {
          console.warn("Invalid user coordinates for ordering");
        }
      }

      if (shufflePlaces && todo) {
        shufflePlaces(output);
        setTodoPlaces(shuffledPlaces);
      }
      setTodoPlaces(output);
    } else {
      setTodoPlaces(slides);
    }
  }, [
    slides,
    filter,
    getSafe,
    status,
    arraySlide,
    origin,
    user,
    user.longitude,
  ]);

  const handleFavorite = (fav, checked) => {
    let condition = checked && todo;
    let condition2 = checked && exp;

    dispatch(
      toggleFavorites(
        condition
          ? { pois: [fav] }
          : condition2
          ? { experiences: [fav] }
          : event
          ? { pois: [fav] }
          : { pois: [fav] }
      )
    );
  };
  SwiperCore.use([Navigation]);

  return (
    <DefaultSwip nohead={nohead} nopadding={nopadding}>
      {!nohead && (
        <SwiperHeader
          navigationPrevRef={navigationPrevRef}
          navigationNextRef={navigationNextRef}
          main={main}
          sub={sub}
          todoPlaces={todoPlaces}
          status={status}
          array={arraySlide}
          ALL_ARRAY={ALL_ARRAY}
          setStatus={setStatus}
          todo={todo}
        />
      )}

      <Swiper
        onInit={(swiper) => {
          swiper.update();
          swiper.params.navigation.prevEl = navigationPrevRef.current;
          swiper.params.navigation.nextEl = navigationNextRef.current;
          swiper.navigation.init();
          swiper.navigation.update();
        }}
        paginationClickable={true}
        onSwiper={(swiper) => {
          swiper.params.navigation.prevEl = navigationPrevRef.current;
          swiper.params.navigation.nextEl = navigationNextRef.current;
        }}
        rebuildOnUpdate={true}
        observer={true}
        observerParents={true}
        watchSlidesProgress={true}
        watchOverflow={true}
        navigation={{
          prevEl: navigationPrevRef.current,
          nextEl: navigationNextRef.current,
        }}
        allowTouchMove={true}
        initialSlide={0}
        spaceBetween={isMobile().phone ? 16 : 24}
        // KEY FIXES FOR ONE CARD AT A TIME:
        slidesPerGroup={1} // Ensures only 1 slide moves at a time
        slideToClickedSlide={false} // Prevents clicking from sliding
        shortSwipes={true} // Enables short swipe gestures
        longSwipes={true} // Enables long swipe gestures
        followFinger={true} // Slide follows finger during swipe
        speed={300} // Smooth transition speed
        touchRatio={1} // 1:1 touch sensitivity
        threshold={10} // 10px minimum to trigger swipe (prevents accidents)
        resistance={true} // Resistance at edges
        resistanceRatio={0.85} // Resistance strength
        preventInteractionOnTransition={true} // Prevents multiple swipes during animation
        freeMode={false}
        centeredSlides={false}
        centerInsufficientSlides={false}
        breakpoints={{
          320: {
            slidesPerView: 1.2,
            slidesPerGroup: 1, // Add to each breakpoint
            spaceBetween: 16,
            centeredSlides: false,
          },
          480: {
            slidesPerView: 1.8,
            slidesPerGroup: 1, // Add to each breakpoint
            spaceBetween: 16,
            centeredSlides: false,
          },
          768: {
            slidesPerView: 2.5,
            slidesPerGroup: 1, // Add to each breakpoint
            spaceBetween: 20,
            centeredSlides: false,
          },
          1024: {
            slidesPerView: nohead ? 2 : 3,
            slidesPerGroup: 1, // Add to each breakpoint
            spaceBetween: 24,
            centeredSlides: false,
          },
          1280: {
            slidesPerView: nohead ? 2.5 : 4,
            slidesPerGroup: 1, // Add to each breakpoint
            spaceBetween: 24,
            centeredSlides: false,
          },
        }}
      >
        {getSafe(() =>
          todoPlaces.map((slide, i) => {
            const distance =
              user.longitude &&
              todo &&
              !origin &&
              !similar &&
              !nearby &&
              getDistance(slide.location?.coordinates, [
                user.longitude,
                user.latitude,
              ]);

            const condition1 =
              distance &&
              todo &&
              !nearby &&
              Math.round(distance).toString().length < 4;
            const condition2 =
              distance &&
              todo &&
              !nearby &&
              Math.round(distance).toString().length >= 4;
            const condition3 =
              distance &&
              todo &&
              nearby &&
              Math.round(distance).toString().length < 4;
            const condition4 =
              distance &&
              todo &&
              nearby &&
              Math.round(distance).toString().length >= 4;
            return (
              <SwiperSlide key={slide._id}>
                <Card id={i}>
                  {filters.stade === "visiting" &&
                    todo &&
                    !similar &&
                    !origin && (
                      <Card.Utils>
                        {condition1
                          ? t("distance.mAwayFromYou", {
                              distance: Math.round(slide.distance),
                            })
                          : condition2
                          ? t("distance.kmAwayFromYou", {
                              distance: Math.round(
                                convertDistance(slide.distance, "km")
                              ),
                            })
                          : condition3
                          ? t("distance.mAwayFromThisPlace", {
                              distance: Math.round(slide.distance),
                            })
                          : condition4
                          ? t("distance.kmAwayFromThisPlace", {
                              distance: Math.round(
                                convertDistance(slide.distance, "km")
                              ),
                            })
                          : null}
                      </Card.Utils>
                    )}
                  {todo &&
                    !similar &&
                    origin &&
                    getSafe(() => (
                      <Card.Utils>
                        {!nearby &&
                          (
                            getPreciseDistance(slide.location?.coordinates, [
                              origin[1],
                              origin[0],
                            ]) -
                            getPreciseDistance(
                              todoPlaces[0].location?.coordinates,
                              [origin[1], origin[0]]
                            )
                          ).toString().length < 4 &&
                          t("distance.mAwayFromYou", {
                            distance: Math.abs(
                              getPreciseDistance(slide.location?.coordinates, [
                                origin[1],
                                origin[0],
                              ]) -
                                getPreciseDistance(
                                  todoPlaces[0].location?.coordinates,
                                  [origin[1], origin[0]]
                                )
                            ),
                          })}

                        {nearby &&
                          (
                            getPreciseDistance(slide.location?.coordinates, [
                              origin[1],
                              origin[0],
                            ]) -
                            getPreciseDistance(
                              todoPlaces[0].location?.coordinates,
                              [origin[1], origin[0]]
                            )
                          ).toString().length < 4 &&
                          t("distance.mAwayFromThisPlace", {
                            distance: Math.abs(
                              getPreciseDistance(slide.location?.coordinates, [
                                origin[1],
                                origin[0],
                              ]) -
                                getPreciseDistance(
                                  todoPlaces[0].location?.coordinates,
                                  [origin[1], origin[0]]
                                )
                            ),
                          })}
                        {!nearby &&
                          (
                            getPreciseDistance(slide.location?.coordinates, [
                              origin[1],
                              origin[0],
                            ]) -
                            getPreciseDistance(
                              todoPlaces[0].location?.coordinates,
                              [origin[1], origin[0]]
                            )
                          ).toString().length >= 4 &&
                          t("distance.kmAwayFromYou", {
                            distance: Math.abs(
                              Math.floor(
                                getPreciseDistance(
                                  slide.location?.coordinates,
                                  [origin[1], origin[0]]
                                ) -
                                  getPreciseDistance(
                                    todoPlaces[0].location?.coordinates,
                                    [origin[1], origin[0]]
                                  )
                              ) / 1000
                            ),
                          })}
                        {nearby &&
                          (
                            getPreciseDistance(slide.location?.coordinates, [
                              origin[1],
                              origin[0],
                            ]) -
                            getPreciseDistance(
                              todoPlaces[0].location?.coordinates,
                              [origin[1], origin[0]]
                            )
                          ).toString().length >= 4 &&
                          t("distance.kmAwayFromThisPlace", {
                            distance: Math.abs(
                              Math.floor(
                                getPreciseDistance(
                                  slide.location?.coordinates,
                                  [origin[1], origin[0]]
                                ) -
                                  getPreciseDistance(
                                    todoPlaces[0].location?.coordinates,
                                    [origin[1], origin[0]]
                                  )
                              ) / 1000
                            ),
                          })}
                      </Card.Utils>
                    ))}

                  <Card.Header
                    id={slide._id}
                    handleFav={handleFavorite}
                    todo={todo}
                    exp={exp}
                    event={event}
                  />
                  <Card.ResponsiveImg
                    onClick={() =>
                      event
                        ? history.push(`/${local}/event/${slide._id}`)
                        : exp
                        ? history.push(`/${local}/experience/${slide._id}`)
                        : todo
                        ? history.push(`/${local}/poi/${slide._id}`)
                        : null
                    }
                    src={getSafe(() =>
                      exp
                        ? slide.places[0].media[0].url
                        : slide.media[0].url
                    )}
                    alt={getSafe(() => slide.title[local], "")}
                  />
                  <Card.Body
                    onClick={() =>
                      event
                        ? history.push(`/${local}/event/${slide._id}`)
                        : exp
                        ? history.push(`/${local}/experience/${slide._id}`)
                        : todo
                        ? history.push(`/${local}/poi/${slide._id}`)
                        : null
                    }
                  >
                    {event && (
                      <Card.UpperText>
                        {format(
                          new Date(slide.misc.eventStartDate),
                          "MMM dd, yyyy"
                        ) +
                          "-" +
                          format(
                            new Date(slide.misc.eventEndDate),
                            "MMM dd, yyyy"
                          )}
                      </Card.UpperText>
                    )}

                    <Card.Title slide={slide} city={todo ? true : false}>
                      {getSafe(() => slide.title[local])}
                    </Card.Title>
                  </Card.Body>
                </Card>
              </SwiperSlide>
            );
          })
        )}
      </Swiper>
      {nohead && !isMobile().phone && (
        <SwiperHeader
          navigationPrevRef={navigationPrevRef}
          navigationNextRef={navigationNextRef}
          nohead={nohead}
        />
      )}
    </DefaultSwip>
  );
}

export default DefaultSwiper;
